import { Skeleton } from '@mui/material';

interface Props {
  className?: string;
}

const TagSkeleton = ({ className }: Props) => {
  return <Skeleton variant="rounded" height={18} width={56} className={className} />;
};

export default TagSkeleton;
